import { Form } from 'formik';
import { connect } from 'react-redux';

import P from 'prop-types';
import React, { Children, isValidElement, cloneElement, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { newErrorNotificationAction } from '../../modules/notifications/Actions';
import getLangData from '../../utils/getLangData';
import Cookies from 'js-cookie';

const FormGroup = props => {
  const {
    handleSubmit,
    heading,
    isLoading,
    children,
    disabled,
    btnType,
    clicked,
    errors,
    errorNotiftication,
    noSubmit = false
  } = props;
  const history = useHistory();
  const goBack = () => {
    history.goBack();
  };
  const dir = Cookies.get('lang')
  // const [isLoading] = useState(true)
  return (
    // <div className='kt-portlet'>
    //   <div className='kt-portlet__head'>
    //     <div className='kt-portlet__head-label'>
    //       <h3 className='kt-portlet__head-title'>{heading}</h3>
    //     </div>
    //   </div>

    //   <Form className='kt-form' onSubmit={handleSubmit}>
    //     <div className='kt-portlet__body'>
    //       <div className='row'>
    //         <div className='col-xl-2'></div>
    //         <div className='col-xl-8'>
    //           <div className='kt-section kt-section--first'>
    //             {disabled
    //               ? Children.map(children, (child) => {
    //                   if (isValidElement(child)) {
    //                     return cloneElement(child, { disabled: true });
    //                   }

    //                   return child;
    //                 })
    //               : children}
    //           </div>
    //         </div>
    //         <div className='col-xl-2'></div>
    //       </div>
    //     </div>
    //     <div className='kt-portlet__foot'>
    //       <div className='kt-form__actions'>
    //         <div className='row'>
    //           <div className='col-12 ml-lg-auto'>
    //             { btnType === 'no-btn' ? ' ' :

    //             <button
    //               type='submit'
    //               className={`btn btn-brand kt-spinner--right kt-spinner--lg kt-spinner--light ${
    //                 isLoading ? "kt-spinner" : ""
    //               }`}
    //                disabled={isLoading || disabled}
    //             >
    //               Submit
    //             </button>
    //             }
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </Form>
    // </div>
    <Form className='edit row block--container my-5' noValidate>
      <div className='col-12'>
        <div className='row d-flex w-100 justify-content-between actions--nav '>
          <div className='col back--action'>
            <Link onClick={goBack} to=''>
              {/* <em className="icon-arrow-left-warshatna" /> */}
              <i
                className={`fas fa-chevron-${dir == 'ar' ? 'right' : 'left'}`}
                style={{
                  padding: '8px',
                  border: '1px solid #000000',
                  borderRadius: '100%',
                  marginRight: '12px',
                  marginLeft: '12px',
                }}
              ></i>
              {getLangData().buttons.back}
            </Link>
            <span>{heading}</span>
          </div>
          {!noSubmit && (
            <div className='col-4 save--action text-right'>
              {btnType === 'no-btn' ? (
                ' '
              ) : (
                <button
                  onClick={() => {
                    console.log(errors, 'errors')
                    if (
                      errors &&
                      typeof errors === 'object' &&
                      Object.keys(errors).length > 0 &&
                      errors.constructor === Object
                    ) {
                      errorNotiftication('Please Fill The Form!');
                    }
                  }}
                  type='submit'
                  className={`btn btn-primary ${isLoading ? 'kt-spinner' : ''}`}
                  disabled={isLoading || disabled}
                >
                  {/* <em className="icon-save-warshatna" /> */}
                  {isLoading ? (
                    <></>
                  ) : (
                    <i
                      className='far fa-save'
                      style={{
                        padding: '8px',
                        fontSize: '17px',
                        marginRight: '12px'
                      }}
                    ></i>
                  )}
                  {isLoading ? <div class='loader'></div> : getLangData().buttons.save}
                </button>
              )}
            </div>
          )}
        </div>
        {/* Content */}
        <div className='row mt-5'>
          <div className='col-12'>
            <div onSubmit={handleSubmit}>
              {disabled
                ? Children.map(children, child => {
                  if (isValidElement(child)) {
                    return cloneElement(child, { disabled: true });
                  }

                  return child;
                })
                : children}
              {/* <div className="form-group">
            <label htmlFor="exampleFormControlInput1">Email address</label>
            <input type="email" className="form-control" id="exampleFormControlInput1" placeholder="name@example.com" />
          </div>
          <div className="form-group">
            <label htmlFor="exampleFormControlSelect1">Example select</label>
            <select className="custom-select form-control" id="exampleFormControlSelect1">
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="exampleFormControlSelect2">Example multiple select</label>
            <select multiple size={3} className="custom-select" id="exampleFormControlSelect2">
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="exampleFormControlTextarea1">Example textarea</label>
            <textarea className="form-control" id="exampleFormControlTextarea1" rows={3} defaultValue={""} />
          </div>
          <div className="form-group">
            <div className="custom-control custom-checkbox">
              <input type="checkbox" className="custom-control-input" id="gridCheck" />
              <label className="custom-control-label" htmlFor="gridCheck">
                Check me out
              </label>
            </div>
          </div>
          <div className="form-group">
            <label className="sr-only" htmlFor="inlineFormInputGroupUsername2">Username</label>
            <div className="input-group mb-2 mr-sm-2">
              <div className="input-group-prepend">
                <div className="input-group-text">@</div>
              </div>
              <input type="text" className="form-control" id="inlineFormInputGroupUsername2" placeholder="Username" />
            </div>
          </div>
          <div className="form-group">
            <label className="sr-only" htmlFor="inlineFormInputGroupUsername2">Username</label>
            <div className="input-group mb-2 mr-sm-2">
              <input type="text" className="form-control" id="inlineFormInputGroupUsername2" placeholder="Username" />
              <div className="input-group-append">
                <div className="input-group-text">@</div>
              </div>
            </div>
          </div>
          <div className="form-group">
            <div className="custom-control custom-radio">
              <input type="radio" id="customRadio1" name="customRadio" className="custom-control-input" />
              <label className="custom-control-label" htmlFor="customRadio1">Toggle this custom radio</label>
            </div>
            <div className="custom-control custom-radio">
              <input type="radio" id="customRadio2" name="customRadio" className="custom-control-input" />
              <label className="custom-control-label" htmlFor="customRadio2">Or toggle this other custom radio</label>
            </div>
          </div>
          <div className="form-group">
            <div className="custom-control custom-switch">
              <input type="checkbox" className="custom-control-input" id="customSwitch1" />
              <label className="custom-control-label" htmlFor="customSwitch1">Toggle this switch element</label>
            </div>
          </div>
          <div className="form-group">
            <div className="custom-file">
              <input type="file" className="custom-file-input" id="customFile" />
              <label className="custom-file-label" htmlFor="customFile">Choose file</label>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="customRange1">Example range</label>
            <input type="range" className="custom-range" id="customRange1" />
          </div> */}
            </div>
          </div>
        </div>
      </div>
    </Form >
  );
};

FormGroup.propTypes = {
  handleSubmit: P.func.isRequired,
  heading: P.any.isRequired,
  isLoading: P.bool,
  disabled: P.bool,
  children: P.oneOfType([P.arrayOf(P.node), P.node]).isRequired
};

FormGroup.defaultProps = {
  isLoading: false,
  disabled: false
};

export default connect(null, {
  errorNotiftication: newErrorNotificationAction
})(FormGroup);
